import { SUPPORTED_ANNOUNCEMENT_FORM_RECIPES } from '../../../constants/recipes';
import { hasAnyRecipe } from '../../modules/foundation/hooks/use-recipe';

export function isAnnouncementFormSupported(patch) {
  return hasAnyRecipe(patch, SUPPORTED_ANNOUNCEMENT_FORM_RECIPES);
}
